import ApiClient from "../helpers/ApiClient";

const baseDiscordEndpoint = `/discord/Discord`;

const getMensagens = () =>
  ApiClient.backendClient.get(`${baseDiscordEndpoint}/mensagens`, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const getColaboradores = () =>
  ApiClient.backendClient.get(`${baseDiscordEndpoint}/colaboradores`, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const getCanais = () =>
  ApiClient.backendClient.get(`${baseDiscordEndpoint}/canais`, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const getMensagem = (titulo) =>
  ApiClient.backendClient.get(`${baseDiscordEndpoint}/mensagem/${titulo}`, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const salvaMensagem = (titulo, data) =>
  ApiClient.backendClient.post(
    `${baseDiscordEndpoint}/salvaMensagem/${titulo}`,
    data,
    {
      headers: {
        Token: process.env.REACT_APP_TOKEN,
      },
    }
  );

const apagaMensagem = (titulo, data) =>
  ApiClient.backendClient.post(
    `${baseDiscordEndpoint}/apagaMensagem/${titulo}`,
    data,
    {
      headers: {
        Token: process.env.REACT_APP_TOKEN,
      },
    }
  );

const DiscordApiClient = {
  getMensagens,
  getColaboradores,
  getCanais,
  getMensagem,
  salvaMensagem,
  apagaMensagem,
};
export default DiscordApiClient;
